import React from 'react';

/**
 * SafeIcon component for safely rendering icons
 * @param {Object} props - Component props
 * @param {Function} props.icon - Icon component to render
 * @param {string} props.className - CSS classes to apply to the icon
 * @returns {JSX.Element} - Rendered icon
 */
const SafeIcon = ({ icon: Icon, className = '', ...props }) => {
  if (!Icon) {
    console.warn('Icon component is missing');
    return null;
  }
  
  return <Icon className={className} {...props} />;
};

export default SafeIcon;